var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentName)?_c(_vm.componentName,_vm._b({tag:"component"},'component',{ item: _vm.item, header: _vm.header },false)):_c('div',[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }